export default function Card({title, parts}) {
    return <div>
        <p className="font-semibold">{title}</p>
        <ul>
            {parts.map((part, index) => (
                <li key={index}>{part}</li>
            ))}
        </ul>
    </div>
}